export interface Settings {
    block_id: string
    email_field_label: string
    code_field_label: string
    hideBackButton?: boolean
    verify_email_section_title: string
    verify_email_submit_button_text: string
    redirect_url: string,
    verificationCode?: string,
}

export const defaultSettings: Settings = {
    block_id: "",
    email_field_label: "Email Address",
    code_field_label: "Verification Code",
    hideBackButton: false,
    verify_email_section_title: "Verify your email",
    verify_email_submit_button_text: "Verify Email",
    redirect_url: "",
}
